document.addEventListener('DOMContentLoaded', (event) => {

  const body = document.body;
  const scrollUp = 'scroll-up';
  const scrollUpNoBanner = 'scroll-up-no-banner';
  const scrollDown = 'scroll-down';
  const topNavHeight = 40;
  const delta = 120;
  let didScroll;
  let lastScrollTop = 0;
  const header = document.querySelector('[data-is-page-index]')
  const isPageIndex = header.dataset.isPageIndex;
  const naviagtionOpacity = document.querySelector('[data-navigation-opacity]');
  const navScrollColours = document.querySelectorAll('[data-nav-scroll-colour]');
  const logoBlack = document.querySelector('[data-logo-black]');
  const logoWhite = document.querySelector('[data-logo-white]');
  const searchOverlay = document.getElementById('search-overlay');
  const searchBar = document.querySelector('[data-search-bar]');

  window.addEventListener('scroll', () => {
    didScroll = true;
  });

  setInterval(function() {
    if (didScroll) {
        if ( isPageIndex == 'true' ){
          updateNav();
        } 
        hasScrolled();
        didScroll = false;
    } else {
      if (window.pageYOffset <= 0 || window.pageYOffset < topNavHeight) {
        body.classList.remove(scrollUp);
        body.classList.remove(scrollUpNoBanner);
        body.classList.remove(scrollDown);
        if ( isPageIndex == 'true' ){
          updateNav();
        } 
        return;
      }  
      if ( window.pageYOffset > 20 ) {
        if ( isPageIndex == 'true' ){
          updateNav();
        }
        return;
      }
    }
  }, 250);

  function hasScrolled() {
    let currentScroll = window.pageYOffset;

    // Check not within the top nav height nor at zero
    if (currentScroll <= 0 || currentScroll < topNavHeight) {
      body.classList.remove(scrollUp);
      body.classList.remove(scrollUpNoBanner);
      body.classList.remove(scrollDown);
      return;
    }
    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - currentScroll) <= delta) return;

    if (currentScroll > lastScrollTop && !body.classList.contains(scrollDown)) {
      // down
      body.classList.remove(scrollUp);
      body.classList.remove(scrollUpNoBanner);
      body.classList.add(scrollDown);
      hideSearchOverlay();
    } else if (
      currentScroll < lastScrollTop &&
      body.classList.contains(scrollDown)
    ) {
      // up
      body.classList.remove(scrollDown);
      showSearchOverlay();
      if (document.getElementById('announcement-banner')) {
        body.classList.add(scrollUp);
      } else {
        body.classList.add(scrollUpNoBanner);
      }
    }
    lastScrollTop = currentScroll;

  }

  function updateNav() {
    let currentScroll = window.pageYOffset;
    if (currentScroll >= 20) {
      logoBlack.classList.remove('hidden');
      logoWhite.classList.add('hidden');
      naviagtionOpacity.classList.remove('lg:bg-opacity-0');
      naviagtionOpacity.classList.add('lg:bg-opacity-100');
      navScrollColours.forEach(element => {
        element.classList.remove('text-white');
        element.classList.add('text-grey-5');
      });
      return;
    }
  }

  function hideSearchOverlay() {
    if (searchBar.classList.contains('hidden')) {
      return;
    } else {
      searchOverlay.classList.add('hidden');
    }      
  }

  function showSearchOverlay() {
    if (searchBar.classList.contains('hidden')) {
      return;
    } else {
      searchOverlay.classList.remove('hidden');
    }      
  }


});

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('[type=number]');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('[type=button]').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};